import {annualRanking as ranking2022} from "../../assets/annual_raking_year_2022";
import {ISearchedRegion} from "../../types/ISearchedRegion";
import {WinningOffersList} from "./winning_offers_list/WinningOffersList";

interface IProps {
    currentRegion: ISearchedRegion;
}

export function RankingList2022(props: IProps) {
    const {currentRegion} = props;
    const rankingRegion = ranking2022.find((cityRecord) => cityRecord.region.slug === currentRegion.slug);

    if (!rankingRegion) {
        return null;
    }

    return <WinningOffersList positions={rankingRegion.positions} />;
}
import {annualRanking as ranking2022} from "../../assets/annual_raking_year_2022";
import {ISearchedRegion} from "../../types/ISearchedRegion";
import {WinningOffersList} from "./winning_offers_list/WinningOffersList";

interface IProps {
    currentRegion: ISearchedRegion;
}

export function RankingList2022(props: IProps) {
    const {currentRegion} = props;
    const rankingRegion = ranking2022.find((cityRecord) => cityRecord.region.slug === currentRegion.slug);

    if (!rankingRegion) {
        return null;
    }

    return <WinningOffersList positions={rankingRegion.positions} />;
}
